import {
  agruparPorDia,
  chaveDoDia,
  diasDaSemana,
  horaLegivel,
  rotuloDoDia,
  type Compromisso,
} from "../../nucleo/compromissos";

/**
 * A visão de calendário semanal (segunda a domingo). Cada dia é uma coluna; cada compromisso, um
 * botão com a hora e o título. O estado vai em `data-estado` e na própria frase: cancelado e
 * concluído aparecem riscados, mas ainda aparecem — a agenda também é o histórico da semana.
 */
export function SemanaDeCompromissos({
  inicio,
  compromissos,
  hoje,
  selecionado,
  aoEscolher,
}: {
  inicio: Date;
  compromissos: readonly Compromisso[];
  hoje: Date;
  selecionado: string | null;
  aoEscolher: (id: string) => void;
}) {
  const grupos = agruparPorDia(compromissos, inicio);
  const chaveDeHoje = chaveDoDia(hoje);
  return (
    <div
      className="grid gap-2 md:grid-cols-7"
      data-testid="semana-de-compromissos"
      role="list"
      aria-label="Compromissos da semana"
    >
      {diasDaSemana(inicio).map((dia) => {
        const chave = chaveDoDia(dia);
        const itens = grupos.get(chave) ?? [];
        return (
          <section
            key={chave}
            role="listitem"
            aria-label={rotuloDoDia(dia)}
            data-testid={`dia-${chave}`}
            data-hoje={chave === chaveDeHoje}
            style={{
              border: `1px solid ${chave === chaveDeHoje ? "var(--brand-deep)" : "var(--line)"}`,
              borderRadius: "var(--r)",
              padding: "8px",
              minHeight: "96px",
              minWidth: 0,
            }}
          >
            <h3 className="titulo-secao">
              {rotuloDoDia(dia)}
            </h3>
            {itens.length === 0 ? (
              <p className="celula-secundaria" style={{ fontSize: "12px" }}>
                Livre
              </p>
            ) : (
              <ul style={{ display: "grid", gap: "6px" }}>
                {itens.map((item) => (
                  <li key={item.id}>
                    <button
                      type="button"
                      className="botao botao--fantasma botao--pequeno"
                      data-testid={`compromisso-${item.titulo}`}
                      data-estado={item.estado}
                      aria-pressed={selecionado === item.id}
                      onClick={() => aoEscolher(item.id)}
                      // Em bloco, não no `inline-flex` do `.botao`: lá a hora, o título e a empresa
                      // viram itens flex que não quebram linha, e o botão vazava da coluna do dia,
                      // por baixo da coluna seguinte, que roubava o clique.
                      style={{
                        display: "block",
                        overflowWrap: "anywhere",
                        width: "100%",
                        textAlign: "left",
                        textDecoration: item.estado === "agendado" ? "none" : "line-through",
                        whiteSpace: "normal",
                      }}
                    >
                      <b>{horaLegivel(item.inicio_em)}</b> {item.titulo}
                      {item.organizacao ? (
                        <span className="celula-secundaria"> · {item.organizacao.nome}</span>
                      ) : null}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </section>
        );
      })}
    </div>
  );
}
